import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
} from 'reactstrap';

import { userHasFeature } from '../../helpers/Features';

import EmptyStateVideo from './components/Video';
import LearnMoreLink from './components/LearnMoreLink';
import UnlockButton from './components/UnlockButton';

const EmptyArchive = () => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Out of sight, still in reach' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Move outdated files to the archive and access them only when you need them - freeing up your workspace for active projects.' })}
        </div>
        {userHasFeature('archive') ? (
          <Button tag={Link} to="/files" color="primary" className="mt-4">
            {intl.formatMessage({ defaultMessage: 'Back to files' })}
          </Button>
        ) : (
          <UnlockButton feature="archive" />
        )}
        <LearnMoreLink
          url="https://help.stockpress.co/en/articles/5937489-archiving-files-and-collections"
          text={intl.formatMessage({ defaultMessage: 'Find out how' })}
        />
      </Col>
      <EmptyStateVideo video="archive" />
    </div>
  );
};

export default EmptyArchive;
